// Common toast messages

import { Notify } from 'quasar'

// Show a generic 'not found' toast
export function showNotFound(model) {
    if (model) return false

    Notify.create({
        message: trans('errors_not_found_title'),
        caption: trans('errors_not_found_message'),
        type: 'negative',
    })

    return true
}

// Show a generic action "success" toast
export function showSuccessToast(message, opts = {}) {
    Notify.create({
        message,
        icon: 'done',
        color: 'positive',
        ...opts,
    })
}
